import { useCallback, useState } from 'react';
import { useLanguage } from '../LanguageContext';
import ButtonIcon from './ButtonIcon';
import { IconCheck, IconCopy } from './icons/ActionIcons';

export default function DonationAccountsSection({ methods = [], loading = false }) {
  const { t } = useLanguage();
  const [copiedId, setCopiedId] = useState(null);

  const copy = useCallback(async (id, text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedId(id);
      setTimeout(() => setCopiedId(null), 2000);
    } catch {
      setCopiedId(null);
    }
  }, []);

  return (
    <section className="section section--accounts" id="donate">
      <div className="section__head section__head--donate">
        <h2>{t('accountsSection.title')}</h2>
        <p className="section__sub">{t('accountsSection.sub')}</p>
      </div>

      {loading ? (
        <p className="section__sub">{t('contributions.loadingOptions')}</p>
      ) : (
        <ul className="donate-grid">
          {methods.map((a) => {
            const isMobile = a.hintKey === 'mobileMoney';
            const hint =
              a.hintKey === 'mobileMoney'
                ? t('accounts.mobileMoney')
                : t('accounts.accountNumber');
            const logoSrc = a.logo ? `${process.env.PUBLIC_URL}/${a.logo}` : null;

            return (
              <li
                key={a.id}
                className={`donate-card ${isMobile ? 'donate-card--mobile' : 'donate-card--bank'}`}
              >
                <div className="donate-card__shine" aria-hidden="true" />
                <div className="donate-card__head">
                  {logoSrc && (
                    <div className="donate-card__logo-wrap">
                      <img
                        src={logoSrc}
                        alt={a.label}
                        className="donate-card__logo"
                        loading="lazy"
                        decoding="async"
                      />
                    </div>
                  )}
                  <div className="donate-card__meta">
                    <h3 className="donate-card__label">{a.label}</h3>
                    <span className="donate-card__hint">{hint}</span>
                  </div>
                </div>

                <div className="donate-card__number-wrap">
                  <code className="donate-card__number" dir="ltr">
                    {a.value}
                  </code>
                </div>

                <button
                  type="button"
                  className="donate-card__copy btn-with-icon"
                  onClick={() => copy(a.id, a.value)}
                  aria-label={`${a.label} — ${hint}`}
                >
                  <ButtonIcon icon={copiedId === a.id ? IconCheck : IconCopy} size={16}>
                    {copiedId === a.id ? t('accounts.copied') : t('accounts.copy')}
                  </ButtonIcon>
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}
